import { useContext, useEffect } from 'react';
import { Outlet, Routes, Route, ScrollRestoration } from 'react-router-dom'

import { observer } from 'mobx-react-lite';
import Box from '@mui/joy/Box';
import Stack from '@mui/joy/Stack';
import Grid from '@mui/joy/Grid';


import Sidebar from 'components/Sidebar';
import { SidebarContained } from 'components/Sidebar';
import SignInForm from 'components/SignInForm';

import PasswordUpdateForm, { PasswordUpdateStartForm } from 'components/PasswordUpdateForm';
import RequestsRoute from 'components/RequestsRoute';
import RequestOverview from 'components/RequestOverview';
import CollabsRoute from 'components/CollabsRoute';
import CollabsListRoute, { CollabsListRouteContainer} from 'components/CollabsListRoute';
import InvitesRoute, { AvailableCollabInvitesRoute, MutualCollabInvitesRoute } from 'components/InvitesRoute';
import CollabFrame from 'components/CollabFrame';
import ProjectContainer   from 'components/ProjectContainer';
import ProjectOverview from 'components/ProjectOverview';
import Topper from 'components/Topper';
import ProjectList from 'components/ProjectList';
import ProjectSettings from 'components/ProjectSettings';
import HomeDealer from 'components/HomeDealer';
import CollabCalendar from 'components/CollabCalendar';
import OpenRoute from 'components/OpenRoute';
import MentorRoute from 'components/MentorRoute';

import IdentityFrame from 'components/IdentityFrame';
import IdentityEditor from 'components/IdentityEditor';
import IdentityPage from 'components/IdentityPage';
import IdentityAssignments from 'components/IdentityAssignments';
import IdentityCollabs from 'components/IdentityCollabs';

import PlansLoggedOut from 'components/PlansLoggedOut';
import AssistantOnly from 'components/AssistantOnly';
import AccountMain from 'components/AccountMain';
import AccountContainer from 'components/AccountContainer';
import SupportContainer from 'components/SupportContainer';
import SupportHome from 'components/SupportHome';
import SupportUser from 'components/SupportUser';
import HomeLoggedOut from 'components/HomeLoggedOut';
import FilesRedirectDownload from 'components/FilesRedirectDownload';
import StripeComplete from 'components/StripeComplete';
import SupportMeCreate from 'components/SupportMeCreate';
import SupportDashboard from 'components/SupportDashboard';
import SupportWorkspace from 'components/SupportWorkspace';
import RequestEmailRender from 'components/RequestEmailRender';
import CollabEmailRender from 'components/CollabEmailRender';
import RequestEmailRedirect from 'components/RequestEmailRedirect';
import ManagerIdentitiesList from 'components/ManagerIdentitiesList';
import ManagerUserCreate from 'components/ManagerUserCreate';
import SudoRedisAdmin from 'components/SudoRedisAdmin';
import RequestOverviewClockOut from 'components/RequestOverviewClockOut';
import { RequestSidebarFullPage } from 'components/RequestSidebar';
import { RequestCalendarFullPage } from 'components/RequestCalendar';
import RequestNewFullPage from 'components/RequestNewFullPage';
import { CollabWorkSpaceSidebarFullPage } from 'components/CollabWorkSpaceSidebar';
import { ClockReportRequest, ClockReportCollab, ClockReportClient, ClockReportAssistant } from 'components/ClockReport';


import DedicatedContainer from 'components/DedicatedContainer';
import DedicatedWorkspace from 'components/DedicatedWorkspace';

import ManagerContainer from 'components/ManagerContainer';
import ManagerHome from 'components/ManagerHome';
import DedicatedDashboard from 'components/DedicatedDashboard';

import TeamAdminContainer from 'components/TeamAdminContainer';
import TeamInviteAccept from './TeamInviteAccept';
import TeamStatusContainer from 'components/TeamStatusContainer';
import ChatContainer from './ChatContainer';
import ChatHome from './ChatHome';
import ChatRoom from './ChatRoom';
import ChatRoomCreate from 'components/ChatRoomCreate';

import IdentityContainer from 'components/IdentityContainer';


import Settings from 'components/Settings';
import { SettingsContainer } from 'components/Settings';
import CalendarAuthSettings, { CalendarPreview } from 'components/CalendarAuthSettings';
import CreditLog from 'components/CreditLog';
import SubscriptionList from 'components/SubscriptionList';

import { AuthContext } from 'contexts/auth_context';

import useFun from 'hooks/useFun';
import { UserProps } from 'stores/user_store';
import LoreBrowser from 'components/LoreBrowser';
import LoreFeaturePlaceholder from 'components/LoreFeaturePlaceholder';
import AssistantOnboarding from 'components/AssistantOnboarding';

import SignUpContainer from 'components/SignUpContainer';

import useSidebar from 'hooks/useSidebar';
import AssistantManagerGate from 'components/AssistantManagerGate';

const NormalFrame = observer(({ currentUser }: { currentUser: UserProps }) => {

    const { showingRegularSidebar } = useSidebar();
    if(!currentUser?.key) {
        return <Outlet />;
    }
    return (
        <AssistantManagerGate currentUser={currentUser}>
        {/* the main container, this will swollow the sidebar and the main content */}
        <Box sx={{
            margin: 0,
            padding: 0,
            // backgroundColor: 'blue',

            minHeight: '100vh',
            overscrollBehavior: 'none',
        }} >

            <Grid
                sx={{
                    width: '99dvw',
                    maxWidth: '100dvw',

                }}
                container>
                <Grid
                    sx={{
                        width: 'var(--SidebarWidth)',

                        display: showingRegularSidebar ? { xs: 'none', sm: 'none', md: 'block' } : 'none',
                        // top: '0px',
                        zIndex: 900,
                    }} >

                    {currentUser?.key && showingRegularSidebar &&
                        <SidebarContained />}

                </Grid>
                <Grid
                    xs={8}
                    className="print-full-height"
                    sx={{
                        minHeight: "100dvh",
                        height: '100dvh',
                        maxWidth: '100dvw',
                        position: 'sticky',

                        margin: showingRegularSidebar ? '0px' : 1,
                        transition: 'all 0.2s',
                        left: showingRegularSidebar ? 'var(--SidebarWidth)' : undefined,
                    }}
                    flexGrow={1}>
                    <Topper />
                    {!showingRegularSidebar ? 1024 : undefined}
                    <Stack
                        className="print-full-height"
                        sx={{
                            top: 'calc(var(--TopperHeight) - 10px)',
                            position: 'relative',
                        }}
                        m={1}
                    >

                        <Outlet />
                    </Stack>

                </Grid>
            </Grid>
            <ScrollRestoration />

        </Box>
        </AssistantManagerGate>
    );

});

export default function MainFrame() {

    const { currentUser } = useContext(AuthContext);
    const { fontSize } = useFun();

    useEffect(() => {
        if(fontSize) {
            document.documentElement.style.fontSize = fontSize;
        }
    }, [fontSize]);

    return (

        <Routes>
            <Route path="/login" element={<SignInForm />} />
            <Route path="/signup" element={
                <SignUpContainer />
            } />

            <Route path="/welcome/:initialSection" element={<PlansLoggedOut />} />
            <Route path="/welcome" element={<PlansLoggedOut />} />
            <Route path="/homepage" element={<HomeLoggedOut />} />

            <Route path="/assistant/welcome" element={<AssistantOnboarding />} />

            <Route path="/stripe/complete/:checkoutSessionId"
                element={<StripeComplete />} />

            <Route path="/password/set/:resetTokenKey/:uuid" element={
                <PasswordUpdateForm />
            } />
            <Route path="/password/change" element={
                <PasswordUpdateStartForm />
            } />


            <Route
                path="/request/:requestKey/from-email"
                element={<RequestEmailRedirect />}
            />


            <Route path="/"
                element={
                    <NormalFrame
                        currentUser={currentUser} />
                }
            >

                <Route index element={<HomeDealer currentUser={currentUser} />} />


                <Route path="/sidebar" element={
                    <Stack m={1}>
                        <Sidebar />
                    </Stack>
                } />


                <Route path="/lore/*" element={
                    <LoreBrowser />
                } />

                <Route path="/settings" element={
                        <SettingsContainer />
                } >
                    <Route index element={<Settings />} />
                    </Route>


                    <Route path="/calendar/settings" element={
                        <CalendarAuthSettings />
                    } />
                    <Route path="/calendar" element={
                        <CalendarPreview />
                    } />

                    <Route path="/team/invite/:uuid" element={
                        <TeamInviteAccept />
                    }/>

                    <Route path="/team/admin" element={
                        <TeamAdminContainer />
                    }/>

                    <Route path="/team" element={
                        <TeamStatusContainer />
                    } />

                <Route path="/chat" element={
                    <ChatContainer />
                }>
                    <Route index element={
                        <ChatHome />}
                />
                    <Route path="new" element={<ChatRoomCreate />} />
                    <Route path=":uuid" element={<ChatRoom />} />

                </Route>

                    <Route path="/email" element={
                        <LoreFeaturePlaceholder
                            slug='feature/business/email'
                        />
                    } />

                    <Route path="/parcel" element={
                        <LoreFeaturePlaceholder
                            slug='feature/business/parcel'
                        />
                    } />

                    <Route path="/roadmap" element={
                        <LoreFeaturePlaceholder
                            slug='sudo/planning/roadmap'
                        />
                    } />

                    <Route path="/phone" element={
                        <LoreFeaturePlaceholder
                            slug='feature/business/phone'
                        />
                    } />


                    <Route path="/dedicated" element={
                        <DedicatedDashboard />
                    } />




                <Route path="/account" element={
                    <AccountContainer />
                }>
                    <Route index element={
                        <AccountMain />}
                    />
                    <Route path="/account/credits" element={
                        <CreditLog />
                    } />
                    <Route path="/account/subscriptions" element={
                        <SubscriptionList />
                    } />
                    <Route path="calendar/settings" element={
                        <CalendarAuthSettings />
                    } />
                    <Route path="calendar" element={
                        <CalendarPreview />
                    } />

                </Route>


                <Route path="/dedicated" element={
                    <DedicatedContainer />
                }>
                    {/*
                    <Route index element={
                        <AccountMain  />}
                    />
                    */}
                    <Route path=":identityUuid" element={
                        <DedicatedWorkspace />
                    } />
                </Route>


                <Route path="/identity" element={
                    <IdentityFrame />
                } />

                <Route path="/identity/new" element={
                    <IdentityFrame />
                } />


                <Route path="/identity/:identityKey" element={
                    <IdentityContainer />
                } >
                    <Route index element={<IdentityPage />} />


                    <Route path="edit" element={
                        <IdentityEditor />
                    } />

                    <Route path="assignments" element={
                        <IdentityAssignments />
                    } />
                    <Route path="collabs" element={
                        <IdentityCollabs />
                    } />
                    <Route path="clock-report" element={
                        <AssistantOnly allowClient={true}>
                            <ClockReportClient />
                        </AssistantOnly>
                    } />
                </Route>

                <Route path="/assistant/:identityKey/clock-report" element={
                        <AssistantOnly>
                            <ClockReportAssistant />
                        </AssistantOnly>
                } />

                <Route path="/files/redirect-download/:association_uuid" element={
                    <FilesRedirectDownload />
                } />

                <Route path="/requests" element={
                    <RequestsRoute />
                } />
                <Route path="/requests/new" element={
                    <RequestNewFullPage />
                } />

                <Route path="/request/:requestKey" element={
                    <AssistantOnly allowClient={true}>
                        <RequestOverview />
                    </AssistantOnly>
                } />
                <Route
                    path="/request/:requestKey/email-render"
                    element={<RequestEmailRender />}
                />
                <Route
                    path="/request/:requestKey/clocks"
                      element={<AssistantOnly><ClockReportRequest /></AssistantOnly>}
                />

                <Route path="/request/:requestKey/sidebar" element={
                    <RequestSidebarFullPage />
                } />
                <Route path="/request/:requestKey/calendar" element={
                    <RequestCalendarFullPage />
                } />

                <Route path="/request/:requestKey/clock-out" element={
                    <RequestOverviewClockOut />
                } />



                <Route path="/projects" element={
                    <ProjectList  />
                } />

                <Route path="/project/:projectKey" element={
                    <ProjectContainer />
                }>
                    <Route index element={ <ProjectOverview /> }/>

                    <Route path="/project/:projectKey/settings" element={
                        <ProjectSettings />
                    } />
                    <Route path="/project/:projectKey/collab/:collabKey" element={
					    <CollabFrame />
                    } />

                </Route>

                <Route path="/invites/available" element={
                    <AssistantOnly><AvailableCollabInvitesRoute /></AssistantOnly>
                } />

                <Route path="/invites/mutual" element={
                    <AssistantOnly><MutualCollabInvitesRoute /></AssistantOnly>
                } />

                <Route path="/invite/:inviteKey" element={
                    <AssistantOnly><InvitesRoute /></AssistantOnly>
                } />

                <Route path="/open" element={
                    <AssistantOnly><OpenRoute /></AssistantOnly>
                } />

                <Route path="/mentor" element={
                    <AssistantOnly><MentorRoute /></AssistantOnly>
                } />

                <Route path="/collabs" element={
                     <CollabsListRouteContainer />
                }>
                    <Route index element={ <CollabsListRoute /> }/>
                    <Route path="/collabs/:status" element={ <CollabsListRoute /> }/>
                </Route>

                <Route path="/collab/:collabKey" element={
                    <CollabsRoute />
                } />

                <Route
                    path="/collab/:collabKey/email-render"
                    element={<CollabEmailRender />}
                />
                <Route
                    path="/collab/:collabKey/clocks"
                      element={<AssistantOnly><ClockReportCollab /></AssistantOnly>}
                />
                <Route path="/collab/:collabKey/sidebar" element={
                    <CollabWorkSpaceSidebarFullPage />
                } />
                <Route path="/collab/:collabKey/calendar" element={
                    <CollabCalendar />
                } />
                <Route path="/collab/:collabKey/:subKey" element={
                    <CollabsRoute />
                } />

                <Route path="/manager" element={
                    <ManagerContainer />
                }>
                    <Route index element={<ManagerHome />} />

                    <Route path="identities" element={
                        <ManagerIdentitiesList />
                    } />
                    <Route path="user-create" element={
                        <ManagerUserCreate />
                    } />
                    <Route path="redis" element={
                        <SudoRedisAdmin />
                    } />


                </Route>

                <Route path="/support" element={
                    <SupportContainer />
                }>
                    <Route index element={<SupportHome />} />

                    <Route path="/support/create" element={
                        <SupportMeCreate />
                    } />
                    <Route path="/support/:collabKey" element={
                        <SupportWorkspace />
                    } />

                    <Route path="/support/dashboard" element={
                        <AssistantOnly><SupportDashboard /></AssistantOnly>
                    } />
                    <Route path="/support/user/:userUuid" element={
                        <AssistantOnly><SupportUser /></AssistantOnly>
                    } />

                </Route>


            </Route>

        </Routes>

    );

}
